export default __webpack_public_path__ + "static/media/emailgroup.f4f5dcb0.svg";